import { useEffect, useState } from "react";

// Is the stage too narrow to hold every figure of a move at a useful size?
//
// Four Mothers, an arrow and a Daughter is about six hundred units of stage.
// Rendered into 375 pixels that puts each figure back down to the forty pixels
// the shield already gives them — which is the exact failure the stage exists
// to fix. So below this width a transposition shows the Mother being read and
// the figure being built, and the bystanders are left to the shield below and
// to the rows under the stage, both of which name all four.
const NARROW = "(max-width: 760px)";

export default function useCompact() {
  const [compact, setCompact] = useState(
    () => typeof window !== "undefined" && window.matchMedia?.(NARROW).matches === true
  );

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const query = window.matchMedia(NARROW);
    const update = () => setCompact(query.matches);
    update();
    // Older Safari only has the deprecated form; this file has to work there.
    if (query.addEventListener) query.addEventListener("change", update);
    else query.addListener(update);
    return () => {
      if (query.removeEventListener) query.removeEventListener("change", update);
      else query.removeListener(update);
    };
  }, []);

  return compact;
}
